import { LANGUAGE } from "../constants";

const getLanguage = (language, localStorageData) => {
  let lang;
  if (localStorageData !== undefined && localStorageData !== null&& localStorageData !== "" && localStorageData.language !== undefined && localStorageData.language !== null && localStorageData.language !== "") {
    lang = localStorageData.language
  } else {
    if (language.match(/^en/) !== null) {
      lang = "en";
    } else if (language.match(/^es/) !== null) {
      lang = "es";
    } else if (language.match(/^fr/) !== null) {
      lang = "fr";
    } else if (language.match(/^pt/) !== null) {
      lang = "pt";
    } else if (language.match(/^he/) !== null) {
      lang = "he";
    } else {
      lang = LANGUAGE;
    }
  }
  return lang;
};

export default getLanguage;
